import React from "react";
import { Stack, Typography, Box } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CustomButton from "@components/CustomButton/CustomButton";
import bgPrincing from "@assets/images/bg-princing.png";

const PricingComparison = () => {
  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        width: "100%",
        margin: "3rem 0",
      }}>
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: 2,
          p: 3,
          width: "400px",
          backgroundImage: `url(${bgPrincing})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}>
        <Stack spacing={2}>
          <Stack direction="row" spacing={1} alignItems="center">
            <CheckCircleIcon sx={{ color: "#0F84FF" }} />
            <Typography>Free 1 month trial for new user</Typography>
          </Stack>
          <Stack direction="row" spacing={1} alignItems="center">
            <CheckCircleIcon sx={{ color: "#0F84FF" }} />
            <Typography>Cancel anytime you want</Typography>
          </Stack>
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end !important",
              width: "100%",
            }}>
            <CustomButton
              bgColor="#0F84FF"
              color="#fff"
              style={{ borderRadius: 10, fontWeight: "bold", margin: "1rem 0" }}
              text={"Full Pricing Comparison"}
              // Full Pricing Comparison
            />
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
};

export default PricingComparison;
